// =============================================================================
// LogoSignet, die SiFaFlow-Bildmarke (Konzept A: "SF"-Signet)
// -----------------------------------------------------------------------------
// Safety-Orange-Schutzfeld (#FF6B00) + "SF" in IBM Plex 700 (#1A1A1A).
// Single Source of Truth für die Bildmarke; ersetzt das frühere Helm-PNG
// an allen Render-Stellen.
//
// Die Text-Wortmarke "SiFa<muted>Flow</muted>" daneben bleibt UNBERÜHRT,
// dieses Signet ist rein die quadratische Mark davor.
//
// Stil identisch zum OG-Signet (src/app/opengraph-image.tsx) und zum Favicon
// (src/app/icon.tsx): echtes IBM Plex via globaler --font-plex-sans-Variable
// (in layout.tsx auf <html> gesetzt), daher kein Font-Outlining nötig.
//
// Brand-Regel: NIE Weiß auf #FF6B00, die Glyphe ist #1A1A1A (6.1:1, AA+AAA-L).
// =============================================================================

type Props = {
  /** Kantenlänge in px (default 36). */
  size?: number;
  /** zusätzliche Klassen, z.B. Margin/Shrink-Overrides. */
  className?: string;
};

export function LogoSignet({ size = 36, className }: Props) {
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: Math.max(3, Math.round(size * 0.18)),
        background: "#FF6B00",
        color: "#1A1A1A",
        fontFamily: "var(--font-plex-sans)",
        fontWeight: 700,
        fontSize: Math.round(size * 0.46),
        letterSpacing: "-0.045em",
        lineHeight: 1,
        userSelect: "none",
      }}
    >
      SF
    </span>
  );
}
